<template>
  <div v-if="expansionPanel" class="'bgc-white-blue" style="background-color: white; padding: 10px; border-radius: 5px">
    <v-row v-if="!isLoading">
      <v-col :cols="12" align="center" justify="center">
        <v-avatar size="60px" color="grey lighten-2">
          <img v-if="imageData" :src="imageData" alt="Avatar" />
          <v-icon v-else size="36px"> mdi-account </v-icon>
        </v-avatar>
      </v-col>
      <v-col :cols="12" align="center" justify="center" v-if="customerCard.customerName">
        <h3 v-text="customerCard.customerName" align="center" justify="center" class="text-h5 c-grey font-weight-bold" />
      </v-col>

      <div v-text="customerCard.identityValue" class="text-h7 c-grey font-weight-bold" />
    </v-row>
    <v-skeleton-loader type="card-avatar" v-else></v-skeleton-loader>
    <v-col>
      <v-row>
        <v-col :cols="6">
          <div class="c-grey text-left font-italic"><b class="c-grey text-left">• NFC</b></div>
        </v-col>
        <v-col :cols="6">
          <div v-text="nfcStatus" class="c-grey text-right font-italic"></div>
        </v-col>
      </v-row>
      <v-row v-for="info in customerCard" :key="info.key">
        <v-col :cols="6">
          <b v-text="'• ' + $t(info.key)" class="c-grey text-left" />
        </v-col>
        <v-col :cols="6">
          <div v-text="formatValue(info.key, info.value)" class="c-grey text-right" :class="info.value == null ? 'font-italic' : ''" />
        </v-col>
      </v-row>
    </v-col>
    
  </div>
  <v-dialog v-else v-model="SHOW" width="600" content-class="hide-scrollbar" @click:outside="onClickOk">
    <v-card>
      <div class="fill-height pa-10 bgc-white">
        <div v-if="isLoading" class="text-center">
          <v-skeleton-loader type="card-avatar"></v-skeleton-loader>
        </div>
        <div v-else>
          <div class="d-flex justify-end">
            <v-btn icon v-if="!isLoading" @click="onClickOk">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <v-row align="center" justify="center">
            <v-avatar size="80px" color="grey lighten-2">
              <img v-if="imageData" :src="imageData" alt="Avatar" />
              <v-icon v-else size="36px"> mdi-account </v-icon>
            </v-avatar>
          </v-row>
          <v-row align="center" justify="center" class="mt-10">
            <div v-text="customerCard.customerName" class="text-h5 mb-4 c-grey font-weight-bold" />
          </v-row>
          <v-row v-for="info in customerCard" :key="info.key">
            <v-col :cols="4">
              <div v-text="'• ' + $t(info.key)" class="c-grey text-left font-weight-bold" />
            </v-col>
            <v-col :cols="8">
              <div v-text="formatValue(info.key, info.value)" class="body-1 c-grey text-right" :class="info.value == null ? 'font-italic' : ''" />
            </v-col>
          </v-row>
          <v-row v-if="note != null">
            <v-col :cols="4">
              <div v-text="'• ' + $t('note')" class="c-grey text-left font-weight-bold" />
            </v-col>
            <v-col :cols="8">
              <div v-text="note.description" class="body-1 c-grey text-right" :class="note.description == null ? 'font-italic' : ''" />
            </v-col>
          </v-row>
          <template v-if="questionsAndAnswers.length > 0">
            <v-divider class="survey-divider"></v-divider>
            <h3 class="text-center">
              {{ $t("surveyResult") }}
            </h3>
            <h4 class="text-center" :style="'color:' + surveyResult.colorCode + ';font-weight:bold'">
              {{ $t(surveyResult.name) }}
            </h4>
            <v-divider class="survey-divider"></v-divider>
            <h3 class="text-center">
              {{ $t("surveyQuestionsAndAnswers") }}
            </h3>
            <v-row v-for="(qa, i) in questionsAndAnswers" :key="i">
              <v-col :cols="6">
                <div v-text="qa.question" class="c-grey text-left font-weight-bold" />
              </v-col>
              <v-col :cols="6">
                <div v-text="qa.answer" class="body-1 c-grey text-right" />
              </v-col>
            </v-row>

          </template>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import UserCard from "./mixin/UserCard";

export default {
  mixins: [UserCard]
};
</script>
<style lang="scss" scoped>
.bgc-light-blue {
  background-color: #f1f8ff;
}

.bgc-white {
  background-color: white;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.survey-divider {
  margin-bottom: 3.5%;
}
</style>



// WEBPACK FOOTER //
// src/components/UserCard.vue